import React, { Component } from 'react';
import { connect } from 'react-redux';
import { css, StyleSheet } from 'aphrodite';
import { Paper, FontIcon } from 'material-ui';
import RaisedButton from '../../tc-ui/raised-button-with-loader';
import { merge, keys, call, compose, map, addIndex, prop, values, pluck, flatten, omit, mapObjIndexed, ifElse, equals, reject, identity } from 'ramda';
import ExtraLine from './extra-line';

const styles = StyleSheet.create({
  container: { padding: '0px 2px 4px 2px', marginBottom: '64px' },
});
const IntegrationExtraSettings = ({
  extraSettings,
  updateSettings,
  saveSettings,
  savingSettings,
  enableExtraSettingSaveButton,
  triggerSnackBarMessage,
}) => {
  return (
    <div>
      <div style={{ marginBottom: '12px' }}>
        <FontIcon className="tc-icon-bulb" color="#ffc800" style={{ fontSize: '24px', top: '-8px' }} />
        <div style={{ display: 'inline-block', width: '90%', marginLeft: '2%' }}>
          You can export one TourConnect extra for each available Service Extras line in Tourplan. <br/>Please configure which extras you would like to export below:
        </div>
      </div>
      <div className={css(styles.container)}>
        {
          call(compose(
            addIndex(map)((key, index) => (
              <ExtraLine
                key={index}
                lineNo={index + 1}
                {...prop(key, extraSettings)}
                otherSelectedExtras={call(compose(
                  flatten,
                  pluck('selectedExtras'),
                  values,
                  omit([key])
                ), extraSettings)}
                removeAnExtraFromAnotherLine={extraName => call(compose(
                  updateSettings,
                  mapObjIndexed(mapObjIndexed((val, k) => call(
                    ifElse(
                      () => equals('selectedExtras', k),
                        reject(equals(extraName)),
                      identity
                    ), val
                  )))
                ), extraSettings)}
                updateLine={payload => updateSettings({ [key]: payload, enableExtraSettingSaveButton: true })}
              />
            )),
            keys
          ), extraSettings)
        }
      </div>
      <Paper style={{ position: 'fixed', bottom: '0px', width: '740px' }}>
        <RaisedButton
          label={enableExtraSettingSaveButton ? 'Save' : 'Saved'}
          secondary
          loader={savingSettings}
          disabled={!enableExtraSettingSaveButton}
          style={{ margin: '12px auto', width: '130px' }}
          onTouchTap={() => {
            saveSettings({ ...extraSettings }, { enableExtraSettingSaveButton: false})
            .catch(() => {
              triggerSnackBarMessage('Unable to save extra settings.');
              updateSettings({ savingExtraSettingsError: true, enableExtraSettingSaveButton: true });
            });
          }}
        />
      </Paper>
    </div>
  );
};

const mapPropsToState = ({ integration }) => ({
  extraSettings: {
    extra1: integration.getIn(['settings', 'extra1']).toJS(),
    extra2: integration.getIn(['settings', 'extra2']).toJS(),
    extra3: integration.getIn(['settings', 'extra3']).toJS(),
    extra4: integration.getIn(['settings', 'extra4']).toJS(),
    extra5: integration.getIn(['settings', 'extra5']).toJS(),
  },
  savingExtraSettingsError: integration.getIn(['settings', 'savingExtraSettingsError']),
  savingSettings: integration.getIn(['settings', 'savingSettings']),
  enableExtraSettingSaveButton: integration.getIn(['settings', 'enableExtraSettingSaveButton']),
});

export default connect(mapPropsToState)(IntegrationExtraSettings);



// WEBPACK FOOTER //
// ./src/app/components/integration/settings/extras-settings.jsx